/**
 * https://www.codeheroes.fr/index.php/2017/11/08/js-classes-abstraites-et-interfaces/
 */
import GroupManager from '../core/GroupManager'
import EventsManager from '../core/EventsManager'
import Logger from '@nematis/js-snippets/assets/js/logging/debug-logger'

export default class BannerAbstract {
  constructor(parameters, LanguageManager) {
    if (this.constructor === BannerAbstract) {
      throw new TypeError('Abstract class "BannerAbstract" cannot be instantiated directly')
    }
    this.parameters = parameters
    this.visible = false
    this.LanguageManager = LanguageManager
    this.GroupManager = new GroupManager(this.LanguageManager)

    this.getHtmlId()
    this.getContent()
  }

  getHtmlId() {
    // Function to implement in child class
    throw new Error('You must implement this function : [getHtmlId]')
  }
  getContent() {
    // Function to implement in child class
    throw new Error('You must implement this function : [getContent]')
  }

  open() {
    EventsManager.dispatchEvent(`rsq.banner.${this.type}.open`)
    document.querySelector(`#${this.getHtmlId()}`).classList.add('active')
    this.visible = true
  }

  close() {
    EventsManager.dispatchEvent(`rsq.banner.${this.type}.close`)
    document.querySelector(`#${this.getHtmlId()}`).classList.remove('active')
    this.visible = false
  }

  toggle() {
    if (this.visible) {
      this.close()
    } else {
      this.open()
    }
  }
}
